// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AssignUsers_wrap__32zAN","head":"AssignUsers_head__1bbip","table":"AssignUsers_table__3nwkD"};